import Link from 'next/link';

import { ErrorPageContentBase } from '../../components/error-page-content-base/error-page-content-base';

import styles from './not-found-content.module.scss';

export const NotFoundContent = () => {
  const linkLabel = 'Go back to Homepage';
  const message = 'Page was not found.';

  return (
    <ErrorPageContentBase
      actionsSlot={
        <Link className={styles['link']} href="/">
          {linkLabel}
        </Link>
      }
      message={message}
    />
  );
};
